import { serverBus } from '@/main';
import Global from '@/scripts/Global'
// import Profile from '@/components/overlay/UserProfile/Profile'
import Profile from '@/components/overlay/UserProfile/UserProfile.vue'
import CreateNewRootFolder from '@/components/overlay/CreateNewRootFolder'
import InviteUser from '@/components/overlay/InviteUser'
import ChooseFolder from '@/components/overlay/ChooseFolder'
import UsersList from '@/components/overlay/UsersList'
import AssignLicense from '@/components/overlay/AssignLicense'

import KeyboardManager from '@/Manager/keyboard.manager';
import DOMManager from '@/Manager/DOM.manager';
import VueSignals from '@/scripts/VueSignals';

let overlayType = Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE)

export default {
    name: 'overlay',
    data (){
        return {
          header: '',
          description: '',
          modalType: '',
          showModal: false,
          purpose:'',
          channel_name:'Channel name',
          folder_cp_id:'',
          selected_channel: '',
          firstname: '',
          name: '',
          username: '',
          email: '',
          image_doc: '',
          showExceedsSize: false,
          data:'',
          block_closing_overlay: false,
        }
      },
     components:{
        Profile,
        CreateNewRootFolder,
        InviteUser,
        ChooseFolder,
        UsersList,
        AssignLicense,
      },
    mounted(){
      serverBus.$on(VueSignals.SHOW_MODAL, (modalStatus) => {
        this.modalType = Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE)
        if(this.block_closing_overlay && overlayType == 'update_profile'){
          this.showModal = true
          KeyboardManager.disableChatMode()
        } else {
          this.showModal = modalStatus
        }

        if(modalStatus){
          KeyboardManager.disableChatMode()
          this.ActivateClose()
        }else {
          DOMManager.RebuildChatArea()
        }
      })

      serverBus.$on(VueSignals.OVERLAY_DATA, (data) => {
        this.data = data
      })

      serverBus.$on(VueSignals.BLOCK_USER_PROFILE_OVERLAY_CLOSE, (success) => {
        this.block_closing_overlay = success
      })


    },
    created() {
     serverBus.$on(VueSignals.SHOW_MODAL, (showModal) => {
      this.showModal = showModal
      if(showModal){
        KeyboardManager.disableChatMode()
      }
     })
    },
  methods: {
    closeModal(){
      if(!this.block_closing_overlay){
        this.showModal = false
        Global.globalValue(VueSignals.SHOW_MODAL, false)
        // To don't directly display the keyboard in responsive when switching channels.
        if (window.screen.width <= 768 && !Global.isELectron()) {
          Global.globalValue(VueSignals.TOOGLE_TEXT_CARET, false);
        }
        KeyboardManager.enableChatMode()
      }
    },
    modalCall: function(){
      this.showModal = true
    },
    ActivateClose(){
      // document.onmousedown = function(e){
      //   if(e.target.classList.contains("modal-wrapper")){
      //     Global.globalValue(VueSignals.SHOW_MODAL, false)
      //   }
      // }
        document.onkeyup = function(e){
          if(e.key == "Escape"){
              Global.globalValue(VueSignals.SHOW_MODAL, false)
              KeyboardManager.enableChatMode()
          }
      }
    },
  }
}
